export const profileActionTypes = {
  SET_PROFILE: 'SET_PROFILE',
  SET_PROFILE_ERROR: 'SET_PROFILE_ERROR',
  SET_BANK_DETAILS: 'SET_BANK_DETAILS',
  SET_BANK_DETAILS_ERROR: 'SET_BANK_DETAILS_ERROR',
  SET_REFERRAL_DATA: 'SET_REFERRAL_DATA',
  SET_REFERRAL_ERROR: 'SET_REFERRAL_ERROR',
};
